import { Beneficiario } from '@/models/beneficiario';
import { BeneficiarioAPI } from '@/api/beneficiario.api';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { Processo } from '@/models/processo';
import { Acampanhamento } from '@/models/acompanhamento';
import { tap } from 'rxjs/operators';
import BeneficiarioAuthService from './beneficiario.auth.service';
import { Telefone } from '@/models/telefone';
import beneficiario from '@/store/modules/beneficiario';
import { Estado } from '@/models/estado';
import { Municipio } from '@/models/municipio';

const beneficiarioApi = new BeneficiarioAPI();

const create = (beneficiario: Beneficiario): AxiosObservable<Beneficiario> => {
  return beneficiarioApi.create(beneficiario);
};

const update = (idProcesso: number, beneficiario: Beneficiario): AxiosObservable<Beneficiario> => {
  return beneficiarioApi.update(idProcesso, beneficiario);
};

const findByCpfNascimento = (
  cpf: number,
  dataNascimento: string
): AxiosObservable<Beneficiario> => {
  return beneficiarioApi.findByCpfNascimento(cpf, dataNascimento);
};

const beneficiarioProcessos = (beneficiarioId: number): AxiosObservable<Processo[]> => {
  return beneficiarioApi.beneficiarioProcessos(beneficiarioId);
};

const beneficiarioProcessoAcompanhamentos = (
  beneficiarioId: number,
  processoId: number
): AxiosObservable<Acampanhamento> => {
  return beneficiarioApi.beneficiarioProcessoAcompanhamentos(beneficiarioId, processoId);
};

const updateAddress = (
  beneficiarioId: number,
  cep: string,
  logradouro: string,
  numeroLogradouro: string,
  complemento: string,
  bairro: string,
  municipioIbge: number,
  telefoneDdd: string,
  telefoneNum: string,
  telefoneDdd2: string,
  telefoneNum2: string,
  email: string,
  recaptcha: string,
  telefones: Telefone[]
): AxiosObservable<Beneficiario> => {
  return beneficiarioApi.updateAddress(
    beneficiarioId,
    cep,
    logradouro,
    numeroLogradouro,
    complemento,
    bairro,
    municipioIbge,
    telefoneDdd,
    telefoneNum,
    telefoneDdd2,
    telefoneNum2,
    email,
    recaptcha,
    telefones
  );
};

const updateAcompanhamentoProcesso = (
  beneficiarioId: number,
  processpId: number,
  situacaoId: number,
  recaptcha: string
): AxiosObservable<any> => {
  return beneficiarioApi.updateAcompanhamentoProcesso(
    beneficiarioId,
    processpId,
    situacaoId,
    recaptcha
  );
};

const generateReportPasseLivre = (body: any): AxiosObservable<any> => {
  return beneficiarioApi.generateReportPasseLivre(body);
};

const getAllEstados = (): AxiosObservable<Estado[]> => {
  return beneficiarioApi.getAllEstados();
};

const getAllMunicipios = (): AxiosObservable<Municipio[]> => {
  return beneficiarioApi.getAllMunicipios();
};

const searchCep = (cep: string): AxiosObservable<any> => {
  return beneficiarioApi.searchCep(cep).pipe(tap(response => {}));
};

export default {
  create,
  update,
  findByCpfNascimento,
  beneficiarioProcessos,
  beneficiarioProcessoAcompanhamentos,
  updateAcompanhamentoProcesso,
  updateAddress,
  generateReportPasseLivre,
  getAllEstados,
  getAllMunicipios,
  searchCep,
};
